export default {
  REPORT_DEFINITIONS: '/report-definitions',
};
